import { makeAuthClient } from "@op/api-client";
import { env } from "../utils/env";

export const authClient = makeAuthClient(env.VITE_API_URL);
